import { render, staticRenderFns } from "./AssetIcon.vue?vue&type=template&id=359be5be&scoped=true&"
import script from "./AssetIcon.vue?vue&type=script&lang=js&"
export * from "./AssetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359be5be",
  null
  
)

export default component.exports